/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createInvoiceDtoFromDiscriminatorValue, serializeDeleteInvoiceRequest, serializeInvoiceDto, serializeUpdateInvoiceRequest, type DeleteInvoiceRequest, type ErrorResponse, type InternalErrorResponse, type InvoiceDto, type UpdateInvoiceRequest } from '../../../models/index.js';
// @ts-ignore
import { CancelRequestBuilderRequestsMetadata, type CancelRequestBuilder } from './cancel/index.js';
// @ts-ignore
import { DiscountRequestBuilderRequestsMetadata, type DiscountRequestBuilder } from './discount/index.js';
// @ts-ignore
import { EmailRequestBuilderRequestsMetadata, type EmailRequestBuilder } from './email/index.js';
// @ts-ignore
import { IssueRequestBuilderRequestsMetadata, type IssueRequestBuilder } from './issue/index.js';
// @ts-ignore
import { PaymentsRequestBuilderNavigationMetadata, PaymentsRequestBuilderRequestsMetadata, type PaymentsRequestBuilder } from './payments/index.js';
// @ts-ignore
import { type VoidRequestBuilder, VoidRequestBuilderRequestsMetadata } from './voidEscaped/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/{invoiceId}
 */
export interface WithInvoiceItemRequestBuilder extends BaseRequestBuilder<WithInvoiceItemRequestBuilder> {
    /**
     * The cancel property
     */
    get cancel(): CancelRequestBuilder;
    /**
     * The discount property
     */
    get discount(): DiscountRequestBuilder;
    /**
     * The email property
     */
    get email(): EmailRequestBuilder;
    /**
     * The issue property
     */
    get issue(): IssueRequestBuilder;
    /**
     * The payments property
     */
    get payments(): PaymentsRequestBuilder;
    /**
     * The void property
     */
    get voidEscaped(): VoidRequestBuilder;
    /**
     * Permanently removes an invoice, along with the payments and refunds recorded on it. There is no undo and no soft-delete: for an invoice that should stay on the record, cancel it while it is still a draft or void it once it has been issued. The call is not idempotent — deleting the same invoice twice returns 404 the second time — and it does not check the invoice's status, so a paid invoice can be deleted.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(body: DeleteInvoiceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Returns one invoice with its line items, payments and computed totals. Administrators see any invoice in the organization; a customer sees only invoices raised against their own customer number; a sales rep sees the invoices of customers they are allowed to see — every customer when their organization record has Can view all customers switched on, otherwise only customers whose RepNumber is one of theirs. An invoice the caller may not see comes back as 404 rather than 403 so an invoice id cannot be used to confirm that a record exists.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithInvoiceItemRequestBuilderGetQueryParameters> | undefined) : Promise<InvoiceDto | undefined>;
    /**
     * Edits an invoice in place. This is a partial update: only the fields present in the body are applied and everything omitted is left as it is, so sending notes alone does not clear the due date. Two fields behave in ways the shape of the request does not show. Only the company name, email, phone and fax on 'customer' are applied — the addresses nested inside it are ignored, and the billing address is changed through the top-level 'billingAddress' field instead (the shipping address cannot be changed here). And an invoice number is only ever assigned to an invoice that does not already have one; sending a different number for an already-numbered invoice is ignored without error. Line items, discounts, payments and lifecycle status all have their own endpoints; this one changes none of them, and it works whatever status the invoice is in.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateInvoiceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvoiceDto | undefined>;
    /**
     * Permanently removes an invoice, along with the payments and refunds recorded on it. There is no undo and no soft-delete: for an invoice that should stay on the record, cancel it while it is still a draft or void it once it has been issued. The call is not idempotent — deleting the same invoice twice returns 404 the second time — and it does not check the invoice's status, so a paid invoice can be deleted.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: DeleteInvoiceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Returns one invoice with its line items, payments and computed totals. Administrators see any invoice in the organization; a customer sees only invoices raised against their own customer number; a sales rep sees the invoices of customers they are allowed to see — every customer when their organization record has Can view all customers switched on, otherwise only customers whose RepNumber is one of theirs. An invoice the caller may not see comes back as 404 rather than 403 so an invoice id cannot be used to confirm that a record exists.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithInvoiceItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Edits an invoice in place. This is a partial update: only the fields present in the body are applied and everything omitted is left as it is, so sending notes alone does not clear the due date. Two fields behave in ways the shape of the request does not show. Only the company name, email, phone and fax on 'customer' are applied — the addresses nested inside it are ignored, and the billing address is changed through the top-level 'billingAddress' field instead (the shipping address cannot be changed here). And an invoice number is only ever assigned to an invoice that does not already have one; sending a different number for an already-numbered invoice is ignored without error. Line items, discounts, payments and lifecycle status all have their own endpoints; this one changes none of them, and it works whatever status the invoice is in.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateInvoiceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Returns one invoice with its line items, payments and computed totals. Administrators see any invoice in the organization; a customer sees only invoices raised against their own customer number; a sales rep sees the invoices of customers they are allowed to see — every customer when their organization record has Can view all customers switched on, otherwise only customers whose RepNumber is one of theirs. An invoice the caller may not see comes back as 404 rather than 403 so an invoice id cannot be used to confirm that a record exists.
 */
export interface WithInvoiceItemRequestBuilderGetQueryParameters {
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithInvoiceItemRequestBuilderUriTemplate = "{+baseurl}/api/invoices/{invoiceId}{?useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithInvoiceItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithInvoiceItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    cancel: {
        requestsMetadata: CancelRequestBuilderRequestsMetadata,
    },
    discount: {
        requestsMetadata: DiscountRequestBuilderRequestsMetadata,
    },
    email: {
        requestsMetadata: EmailRequestBuilderRequestsMetadata,
    },
    issue: {
        requestsMetadata: IssueRequestBuilderRequestsMetadata,
    },
    payments: {
        requestsMetadata: PaymentsRequestBuilderRequestsMetadata,
        navigationMetadata: PaymentsRequestBuilderNavigationMetadata,
    },
    voidEscaped: {
        requestsMetadata: VoidRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithInvoiceItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithInvoiceItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeleteInvoiceRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    get: {
        uriTemplate: WithInvoiceItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
    },
    put: {
        uriTemplate: WithInvoiceItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateInvoiceRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
